<template>
  <!-- Il bottone Compleanni è nella barra azioni della home (Appointments). -->
  <div>
    <birthday-registry-modal ref="birthdayRegistry" />
  </div>

</template>

<script>
import BirthdayRegistryModal from "@/components/modals/birthdayRegistry";
import moment from "moment";
moment.locale("it");

export default {
  components: { BirthdayRegistryModal },
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {},
};
</script>
